import * as url from '../../helpers/url_helper';
import { get, post } from '../../helpers/api_helper';

export const getAllUnreadNotificationDataAPI = () => {
	return get(url.GET_ALL_UNREAD_NOTIFICATIONS_DATA);
};

export const markAsReadNotification = notificationId => {
	return get(url.MARK_AS_READ_NOTIFICATION + '/' + notificationId);
};

export const getAllNotificationDataAPI = data => {
	return post(url.GET_ALL_NOTIFICATIONS_DATA, data);
};

export const markAllAsReadNotification = () => {
	return get(url.MARK_ALL_AS_READ_NOTIFICATION);
};
